var __jsx = React.createElement;
import React from 'react';
import NavMenu from '../../../molecules/NavList';
var MainMenu = function MainMenu(_ref) {
  var mainMenuCollection = _ref.mainMenuCollection,
    openDropdownOnClick = _ref.openDropdownOnClick;
  var mainMenu = mainMenuCollection === null || mainMenuCollection === void 0 ? void 0 : mainMenuCollection.items;
  return __jsx("nav", {
    className: "nva-header__main-menu"
  }, __jsx(NavMenu, {
    className: "nva-header__main-menu-list",
    menu: mainMenu,
    menuType: "link",
    openDropdownOnClick: openDropdownOnClick,
    parentType: "header"
  }));
};
export default MainMenu;